import { API_CONFIG, getApiUrl } from '../config/api';

export interface SendOtpResponse {
  ok: boolean;
  statusCode: string;
  statusMessage: string;
  transactionId: string;
  data: {
    status: string;
  };
  clientCorrelator: string;
  errorMessage: string | null;
  devMode?: boolean;
  devOtp?: string;
}

export interface SendOtpResult {
  success: boolean;
  data?: SendOtpResponse;
}

export interface VerifyOtpResponse {
  ok: boolean;
  verified: boolean;
  errorMessage: string | null;
}

export interface VerifyOtpResult {
  success: boolean;
  errorMessage?: string;
}

export const sendOtp = async (msisdn: string): Promise<SendOtpResult> => {
  try {
    const response = await fetch(getApiUrl(API_CONFIG.ENDPOINTS.SEND_OTP), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ msisdn }),
    });

    if (!response.ok) {
      return { success: false };
    }

    const data: SendOtpResponse = await response.json();
    return { success: data.ok === true, data };
  } catch {
    return { success: false };
  }
};

export const verifyOtp = async (msisdn: string, otp: string): Promise<VerifyOtpResult> => {
  try {
    const response = await fetch(getApiUrl(API_CONFIG.ENDPOINTS.VERIFY_OTP), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ msisdn, otp }),
    });

    const data: VerifyOtpResponse = await response.json();

    if (data.ok === true && data.verified === true) {
      return { success: true };
    }

    return {
      success: false,
      errorMessage: data.errorMessage || 'There is an error please try again',
    };
  } catch {
    return {
      success: false,
      errorMessage: 'There is an error please try again',
    };
  }
};
